import React from "react";

import Layout from "../containers/layout";
import GraphQLErrorList from "../components/graphql-error-list";
import SEO from "../components/seo";
import PageContainer from "../components/pageContainer";
import MagazinMain from "../components/magazinMain";

const Actions = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const magazinPreview = data && data?.magazinPreview?.nodes;
  const allServices = data && data?.allServices?.nodes;
  const magazin = data && data?.magazin?.nodes;
  const tags = data && data?.tags?.nodes;

  return (
    <Layout services={allServices} tags={tags} magazin={magazinPreview}>
      <SEO
        title={"Magazín"}
        description={"Magazín Beauty Body Clinic."}
        keywords={["Blog", "Články", "Magazín"]}
      />
      <PageContainer>
        <MagazinMain magazin={magazin} />
      </PageContainer>
    </Layout>
  );
};

export default Actions;
